import React from 'react';
import { useHistory } from 'react-router-dom';

const UserComponentUser = ({ userCounts }) => {
 
  return (
    <div className="user-count-component mb-4" style={{ marginTop: '3rem' }}>
     


      <h4 >Publication Statistics</h4>

      {/* First Row */}
      <div className="row mb-3"style={{ marginTop: '3rem' }}>
        <div className="col-4">
          <div className="text-white" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' ,background:'rgb(100, 181, 179)'}}>
            <strong>UGC:</strong> {userCounts.UGC}
          </div>
        </div>
        <div className="col-4">
          <div className="text-white" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' ,background:'rgb(211, 142, 165)'}}>
            <strong>WOS:</strong> {userCounts.WOS}
          </div>
        </div>
        <div className="col-4">
          <div className="text-dark" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center',background:'rgb(101, 214, 139)' }}>
            <strong>SCI:</strong> {userCounts.SCI}
          </div>
        </div>
      </div>

      {/* Second Row */}
      <div className="row mb-3">
        <div className="col-4">
          <div className="text-white" style={{ padding: '15px', borderRadius: '5px', textAlign: 'center',background:'rgb(223, 216, 18)' }}>
            <strong>SCOPUS:</strong> {userCounts.SCOPUS}
          </div>
        </div>
        <div className="col-4">
          <div className="text-white" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' ,background:'rgb(178, 188, 188)'}}>
            <strong>OTHERS:</strong> {userCounts.OTHERS}
          </div>
        </div>
        <div className="col-4">
          <div className="text-white" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' ,background:'rgb(167, 156, 221)'}}>
            <strong>Q1:</strong> {userCounts.Q1}
          </div>
        </div>
      </div>

      {/* Third Row */}
      <div className="row">
        <div className="col-4">
          <div className="bg-info text-white" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' }}>
            <strong>Q2:</strong> {userCounts.Q2}
          </div>
        </div>
        <div className="col-4">
          <div className="bg-success text-white" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' }}>
            <strong>Q3:</strong> {userCounts.Q3}
          </div>
        </div>
        <div className="col-4">
          <div className="bg-warning text-dark" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' }}>
            <strong>Q4:</strong> {userCounts.Q4}
          </div>
        </div>
        <div className="col-12 mt-3">
          <div className="bg-primary text-white" style={{ padding: '25px', borderRadius: '5px', textAlign: 'center' }}>
            <strong>Total:</strong> {userCounts.Total}
          </div>
        </div>
      </div>
    </div>

  );
};

export default UserComponentUser;
